
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { priceRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import SelectApportionPeriod from "./datetimepicker/select-apportion-period.vue";
import _ from "lodash-es";

const finance = namespace("finance");
const base = namespace("base");
const app = namespace("app");
const setting = namespace("setting");

@Component({ components: { SelectApportionPeriod } })
export default class CreateOtherPayment extends Vue {
  @finance.Action createOtherPayment;
  @finance.Action queryOtherPaymentPaymentTypes;
  @base.Action getDictionaryList;
  @app.State btnLoading;
  @app.Mutation btnStartLoading;
  @app.Mutation btnStopLoading;
  @setting.Action getPatternPaymentList;
  API_URL = window.API_URL;
  get breadData() {
    return [
      { name: t("finance.payment-order"), path: "/finance/payment-order" },
      { name: t("finance.new-bill-payment") }
    ];
  }
  payWayList: any[] = [];
  paymentFormData = {
    payeeName: "",
    paidMethod: "",
    paidAmount: "",
    paidTime: "",
    remark: "",
    paymentTypeCas: ["9"], //默认取值9-其他收款
    paymentType: "9", //默认取值9-其他收款
    secondaryPaymentType: "",
    allocationCycle: ""
  };
  paymentFormRules = {
    paidMethod: [{ required: true, message: t("finance.select-mode-payment"), trigger: "change" }],
    paidTime: [{ required: true, message: t("v216_6.please-select-the-payment-time"), trigger: "change" }],
    paidAmount: [
      {
        required: true,
        message: t("finance.input-payment-amount")
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    payeeName: [{ required: true, message: t("finance.enter-receiver"), trigger: "blur" }],
    remark: [{ required: true, message: t("v210831.please-enter-a-digest"), trigger: "blur" }]
  };
  otherPaymentPaymentTypesList = [];
  otherPaymentPaymentTypesProps: any = {
    label: "dataDesc",
    value: "dataValue",
    children: "childPaymentTypeList"
  };
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  created() {
    this.init();
  }

  submitForm(formName) {
    (this.$refs[formName] as any).validate(valid => {
      if (valid) {
        this.addOtherpayment();
      } else {
        console.log("error submit!!");
      }
    });
  }
  init() {
    this.getPatternPaymentList({
      status: "1"
    }).then(data => {
      this.payWayList = this.$safeValue(data, "data", []);
    });
    this.getOtherPaymentPaymentTypes();
  }
  async getOtherPaymentPaymentTypes() {
    const res = await this.queryOtherPaymentPaymentTypes();
    this.otherPaymentPaymentTypesList = this.addLeafFlag(res.data || []);
  }
  // 过滤空children
  addLeafFlag(list) {
    const f = function (list) {
      list.forEach(item => {
        if (!item.childPaymentTypeList || item.childPaymentTypeList.length < 1) {
          delete item.childPaymentTypeList;
        } else {
          f(item.childPaymentTypeList);
        }
      });
    };
    f(list);
    return list;
  }
  async addOtherpayment() {
    this.btnStartLoading();
    this.createOtherPayment({ ..._.omit(this.paymentFormData, ["paymentTypeCas"]) })
      .then(() => {
        this.$message.success(t("base.success") as any);
        this.$router.push(`/finance/payment-order`);
      })
      .finally(() => {
        this.btnStopLoading();
      });
  }
  datetimeChange(data) {
    this.paymentFormData.allocationCycle = data;
  }
  changeCasPaymentType(data) {
    this.paymentFormData.paymentType = data[0];
    // 判断是否选择了第二级
    this.paymentFormData.secondaryPaymentType = data && data.length > 1 ? data[1] : "";
  }
}
